import { render, staticRenderFns } from "./CallDisposeList.vue?vue&type=template&id=d362ad24&scoped=true"
import script from "./CallDisposeList.vue?vue&type=script&lang=js"
export * from "./CallDisposeList.vue?vue&type=script&lang=js"
import style0 from "./CallDisposeList.vue?vue&type=style&index=0&id=d362ad24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362ad24",
  null
  
)

export default component.exports